import auth from './auth'
import authors from './authors'
import banners from './banners'
import books from './books'
import collections from './collections'
import coupons from './coupons'
import courses from './courses'
import filiations from './filiations'
import magazines from './magazines'
import plans from './plans'
import purchases from './purchases'
import subscriptions from './subscriptions'
import transfers from './transfers'
import usageTerms from './usageTerms'
import users from './users'
import videos from './videos'
import csvReports from './csvReports'
import xmlReports from './xmlReports'
import importCsvs from './importCsvs'
import divulgations from './divulgations'

const V = path => () => import(`@/views/${path}.vue`)

export default [
  {
    path: '/',
    component: V('Base'),
    children: [
      {
        name: 'home',
        path: '',
        component: V('home/Dashboard'),
        meta: { title: 'Dashboard' },
      },
      {
        name: 'systemParameters',
        path: 'parameters',
        component: V('parameters/Form'),
        meta: {
          title: 'Parâmetros do Sistema',
          breadcrumb: [{ title: 'Parâmetros' }],
        },
      },
      ...authors(V),
      ...banners(V),
      ...books(V),
      ...collections(V),
      ...coupons(V),
      ...courses(V),
      ...divulgations(V),
      ...filiations(V),
      ...magazines(V),
      ...plans(V),
      ...purchases(V),
      ...subscriptions(V),
      ...transfers(V),
      ...usageTerms(V),
      ...users(V),
      ...videos(V),
      ...csvReports(V),
      ...xmlReports(V),
      ...importCsvs(V),
    ],
  },
  {
    name: 'loadSession',
    path: '/load-session',
    component: V('LoadSession'),
    meta: { title: 'Carregando a sessão', public: true },
  },
  ...auth(V),
  {
    path: '*',
    component: V('NotFound'),
  },
]
